import { createRouter, createWebHistory } from 'vue-router';
import { routes as app } from '../app';
import { loginStore } from '../app/login/vuex/index';
import ability from '../app/login/ability';
import beforeEach from './beforeEach';

const Login = () => import(/* webpackChunkName: "main-bundle" */ '../app/login/main.vue');
const Notice = () => import(/* webpackChunkName: "main-bundle" */ '../app/notice/notice.vue');
const SenhaAtualizada = () => import(/* webpackChunkName: "main-bundle" */ '../app/senhaatualizada/main.vue');
const MensagemSucesso = () => import(/* webpackChunkName: "main-bundle" */ '../app/mensagemsucesso/main.vue');
const NotFound = () => import(/* webpackChunkName: "main-bundle" */ '../NotFound.vue');
const AccessDenied = () => import(/* webpackChunkName: "main-bundle" */ '../AccessDenied.vue');

/*  Solicitado que a pré adesão ficasse desativa até a nova adesão ser implementada tarefa #OB-802 */
// const ValidacaoElegilidade = () => import(/* webpackChunkName: "pre-adesao-bundle" */ '../app/module/principal/solicitacaoadesao/validacaoelegibilidade.vue');

const login = {
  name: 'auth',
  path: '/auth',
  component: Login,
  // redirect: { name: 'auth' },
  meta: { requiresAuth: false, icon: 'sign-out-alt' },
};
const notice = {
  name: 'notices',
  path: '/notices',
  component: Notice,
  breadcrum: 'Notícias',
  // redirect: { name: 'auth' },
  meta: { requiresAuth: true, icon: 'bell' },
};

const novasenha = {
  name: 'senha-atualizada',
  path: '/senha-atualizada',
  component: SenhaAtualizada,
  // redirect: { name: 'auth' },
  meta: { requiresAuth: false },
};

const mensagemsucesso = {
  name: 'mensagem-sucesso',
  path: '/mensagem-sucesso',
  component: MensagemSucesso,
  // redirect: { name: 'auth' },
  meta: { requiresAuth: false },
};

const notfound = {
  path: '/:catchAll(.*)', component: NotFound,
};

const accessDenied = {
  name: 'access-denied',
  path: '/acesso-negado',
  component: AccessDenied,
};

/*  Solicitado que a pré adesão ficasse desativa até a nova adesão ser implementada tarefa #OB-802 */
// const validacaoelegilidade = {
//   name: 'pre-adesao',
//   path: '/pre-adesao',
//   component: ValidacaoElegilidade,
// };

const routes = [
  ...app,
  notice,
  login,
  novasenha,
  mensagemsucesso,
  /*  Solicitado que a pré adesão ficasse desativa até a nova adesão ser implementada tarefa #OB-802 */
  // validacaoelegilidade,
  notfound,
  accessDenied,
];

const router = createRouter({
  routes,
  history: createWebHistory(),
  linkActiveClass: 'active',
//  saveScrollPosition: true,
});

/**
  * Before a route is resolved we check for
  * the token if the route is marked as
  * requireAuth.
*/
router.beforeEach(beforeEach);

const afterEach = (() => {
  const store = loginStore();
  // se possuir a permissao abaixo, nao for admin e nao tiver setado terminal entao vai para terminal ura
  if (ability.can('ura', 'protocolodocumento')
    && !store.currentUser.admin
    && !store.currentUraBean.enabled) {
    router.push({ name: 'ura' });
  }
});

router.afterEach(afterEach);

export default router;
